export const dataMonthly = [
  {
    id: '1',
    label: 'free',
    price: 0,
    condition: '',
    title: 'For personal hobby servers and schools',
    features: [
      {
        id: '1',
        check: true,
        title: 'Unlimited servers (never paused)',
      },
      {
        id: '2',
        check: true,
        title: 'All security features',
      },
      {
        id: '3',
        check: true,
        title: 'Standard branding',
      },
      {
        id: '4',
        check: true,
        title: 'Standard support',
      },
      {
        id: '5',
        check: true,
        title: 'Limited moderation',
      },
      {
        id: '6',
        check: true,
        title: 'Customisable verification',
      },
      {
        id: '7',
        check: true,
        title: 'No adds',
      },
    ],
  },
  {
    id: '2',
    label: 'pro',
    price: 10,
    condition: 'per server/month',
    title: 'For growing servers and mid-size communities',
    features: [
      {
        id: '1',
        check: false,
        title: 'Everything in Free plus:',
      },
      {
        id: '2',
        check: true,
        title: 'Advanced security features',
      },
      {
        id: '3',
        check: true,
        title: 'Super low latency',
      },
      {
        id: '4',
        check: true,
        title: 'Customisable notifications',
      },
      {
        id: '5',
        check: true,
        title: 'Image captcha verification',
      },
      {
        id: '6',
        check: true,
        title: 'Priority support',
      },
      {
        id: '7',
        check: true,
        title: 'Dedicated shard',
      },
    ],
  },
  {
    id: '3',
    label: 'enterprise',
    price: 300,
    condition: 'per server/year',
    title: 'For large servers, businesses and platforms',
    features: [
      {
        id: '1',
        check: false,
        title: 'Everything in Free & Pro plus:',
      },
      {
        id: '2',
        check: true,
        title: 'Early-access features',
      },
      {
        id: '3',
        check: true,
        title: 'Custom branding (Whitelabel)',
      },
      {
        id: '4',
        check: true,
        title: 'Dedicated support',
      },
      {
        id: '5',
        check: true,
        title: 'Custom limits',
      },
      {
        id: '6',
        check: true,
        title: 'Dedicated infra',
      },
    ],
  },
];
